import { createFileRoute, redirect } from '@tanstack/react-router';

import { medplum } from '@/config/medplum';
import { APP_PERMISSIONS, getUserPermissions, hasPermission } from '@/lib/auth/permissions';

type SearchParams = {
  error?: string;
};

export const Route = createFileRoute('/')({
  validateSearch: (search: Record<string, unknown>): SearchParams => ({
    error: typeof search.error === 'string' ? search.error : undefined,
  }),
  beforeLoad: async () => {
    const activeLogin = medplum.getActiveLogin();

    if (activeLogin) {
      const { permissions } = await getUserPermissions();
      // Empty permissions with an activeLogin means the profile couldn't be loaded
      // (expired/invalid token). Stay on the login page — onUnauthenticated will
      // clear the stale session.
      if (permissions.length === 0) return;
      if (hasPermission(permissions, APP_PERMISSIONS.PATIENT_CARE)) {
        throw redirect({ to: '/patients', replace: true });
      }
      if (hasPermission(permissions, APP_PERMISSIONS.PATIENT_MEDREC)) {
        throw redirect({ to: '/patients', search: { tab: 'medrec' }, replace: true });
      }
      throw redirect({ to: '/dashboard', replace: true });
    }
  },
});
